import { LOGIN_SESSION_WINDOW_UNTIL_KEY } from '../assets/constants'

const TWENTY_FOUR_H_MS = 24 * 60 * 60 * 1000

/** Start or extend the “logged in today” window: 24 hours from now (stored as epoch ms in localStorage). */
export function setLoginSessionWindow24h(): void {
	try {
		localStorage.setItem(LOGIN_SESSION_WINDOW_UNTIL_KEY, String(Date.now() + TWENTY_FOUR_H_MS))
	} catch {
		// ignore storage failures
	}
}

/** True while `Date.now()` is before the stored window end. Missing or invalid storage → false (treat as expired). */
export function isLoginSessionWindowValid(): boolean {
	try {
		const raw = localStorage.getItem(LOGIN_SESSION_WINDOW_UNTIL_KEY)
		if (!raw) return false
		const until = Number(raw)
		if (!Number.isFinite(until)) return false
		return Date.now() < until
	} catch {
		return false
	}
}

export function clearLoginSessionWindow(): void {
	try {
		localStorage.removeItem(LOGIN_SESSION_WINDOW_UNTIL_KEY)
	} catch {
		// ignore
	}
}
